<template>
  <c-flex>
    <c-box>
      <c-text v-if="order.totalSum">
        <Price
          v-if="order.orderNumber"
          :price="Number(order.totalSum.price)"
          :currency="order.totalSum.currencyCode"
          align="right"
          data-cy="order-total-price"
        />
        <Price
          v-else
          :price="totalPriceWithServiceProductsAndHandlingFee"
          :currency="order.totalSum.currencyCode"
          align="right"
        />
      </c-text>
    </c-box>
  </c-flex>
</template>

<script lang="ts">
import Price from "@/design-system/elements/Price.vue";
import { isSurfaceTreatmentFeeRequired } from "@/util/ProductUtil";
import { CBox, CFlex, CText } from "@chakra-ui/vue";
import { IOrderRow, IServiceproduct } from "@iloq/shared";
import { defineComponent } from "vue";
import { mapState } from "vuex";

export default defineComponent({
  name: "ShoppingCartTotalPrice",
  components: {
    Price,
    CFlex,
    CBox,
    CText,
  },
  props: {
    order: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapState("partnerInfo", {
      partnerInfo: "partnerInfo",
    }),
    ...mapState("productData", {
      handlingFee: "handlingFee",
      surfaceTreatmentFee: "surfaceTreatmentFee",
    }),
    totalPriceWithServiceProductsAndHandlingFee(): number {
      let totalPercentage = 0;
      this.serviceProducts.forEach((row: IOrderRow) => {
        totalPercentage += (row.product as IServiceproduct).price_factor;
      });

      const totalPriceWithServiceProducts =
        this.order.totalSum.price + this.order.totalSum.price * totalPercentage;

      const handlingFeeRequired = !this.partnerInfo.hasFreeHandling && this.handlingFee !== null;
      const handlingFeePrice = handlingFeeRequired ? this.handlingFee.price : 0;

      const surfaceTreatmentFeeRequired =
        this.surfaceTreatmentFee !== null && isSurfaceTreatmentFeeRequired(this.order.rows);
      const surfaceTreatmentFeePrice = surfaceTreatmentFeeRequired
        ? this.surfaceTreatmentFee.price
        : 0;

      return totalPriceWithServiceProducts + handlingFeePrice + surfaceTreatmentFeePrice;
    },
    serviceProducts(): IOrderRow[] {
      return this.order.rows.filter((row: IOrderRow) =>
        this.$store.state.productData.serviceproducts.ids.includes(row.product?.id)
      );
    },
  },
});
</script>
